import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SchemaOrg from '../../components/feature/SchemaOrg';

export default function ChecklistPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [checkedItems, setCheckedItems] = useState<{ [key: string]: boolean }>({});

  const toggleItem = (id: string) => {
    setCheckedItems(prev => ({ ...prev, [id]: !prev[id] }));
  };

  const checklists = [
    {
      title: '搬家前 4 週準備清單',
      icon: 'ri-calendar-line',
      color: 'teal',
      items: [
        { id: '4w-1', text: '決定搬家日期，避開月初月底旺季' },
        { id: '4w-2', text: '聯絡 2-3 家搬家公司比價（建鈞搬家提供免費估價）' },
        { id: '4w-3', text: '確認新家交屋日期和鑰匙領取時間' },
        { id: '4w-4', text: '通知房東搬家日期（租屋者）' },
        { id: '4w-5', text: '開始整理不需要的物品，規劃捐贈或丟棄' },
        { id: '4w-6', text: '測量新家空間，確認大型家具是否能放入' },
        { id: '4w-7', text: '預約搬家公司，確認搬家時間和費用' },
        { id: '4w-8', text: '購買或準備打包材料（紙箱、氣泡紙、膠帶）' }
      ]
    },
    {
      title: '搬家前 2 週準備清單',
      icon: 'ri-calendar-check-line',
      color: 'emerald',
      items: [
        { id: '2w-1', text: '開始打包非日常用品（書籍、裝飾品、換季衣物）' },
        { id: '2w-2', text: '向管委會申請搬家許可和電梯使用' },
        { id: '2w-3', text: '申請臨時停車證（舊家和新家）' },
        { id: '2w-4', text: '通知郵局辦理郵件轉寄服務' },
        { id: '2w-5', text: '通知銀行、信用卡公司更改地址' },
        { id: '2w-6', text: '辦理水電瓦斯過戶或新申請' },
        { id: '2w-7', text: '辦理網路、第四台遷移或新裝' },
        { id: '2w-8', text: '整理重要文件（身分證、健保卡、存摺等）' }
      ]
    },
    {
      title: '搬家前 1 週準備清單',
      icon: 'ri-time-line',
      color: 'teal',
      items: [
        { id: '1w-1', text: '加速打包，只留搬家當天需要的物品' },
        { id: '1w-2', text: '清空冰箱，停止採購生鮮食品' },
        { id: '1w-3', text: '清理冷凍庫，讓冰箱自然除霜' },
        { id: '1w-4', text: '拍照記錄家具擺設和電器線路連接' },
        { id: '1w-5', text: '確認搬家公司聯絡方式和搬家時間' },
        { id: '1w-6', text: '準備搬家當天的餐點和飲料' },
        { id: '1w-7', text: '清點貴重物品，規劃自行攜帶' },
        { id: '1w-8', text: '通知親友新地址' }
      ]
    },
    {
      title: '搬家前 1 天準備清單',
      icon: 'ri-alarm-line',
      color: 'amber',
      items: [
        { id: '1d-1', text: '完成所有物品打包，只留當晚和隔天早上用品' },
        { id: '1d-2', text: '拔除所有電器插頭，整理電線' },
        { id: '1d-3', text: '清空冰箱，擦拭乾淨並保持門開啟' },
        { id: '1d-4', text: '準備搬家當天的換洗衣物和盥洗用品' },
        { id: '1d-5', text: '確認新家鑰匙已領取' },
        { id: '1d-6', text: '再次確認搬家公司時間和聯絡方式' },
        { id: '1d-7', text: '準備零錢和現金（支付搬家費用）' },
        { id: '1d-8', text: '充飽手機電池，準備行動電源' }
      ]
    },
    {
      title: '搬家當天檢查清單',
      icon: 'ri-truck-line',
      color: 'orange',
      items: [
        { id: 'day-1', text: '早起準備，確保搬家公司到達時一切就緒' },
        { id: 'day-2', text: '與搬家師傅確認物品清單和注意事項' },
        { id: 'day-3', text: '指導搬家師傅哪些物品需要特別小心' },
        { id: 'day-4', text: '貴重物品、重要文件自行攜帶' },
        { id: 'day-5', text: '最後巡視舊家，確認沒有遺漏物品' },
        { id: 'day-6', text: '檢查櫃子、抽屜、陽台、儲藏室' },
        { id: 'day-7', text: '關閉所有水電開關' },
        { id: 'day-8', text: '拍照記錄舊家狀況（租屋者）' },
        { id: 'day-9', text: '到達新家後，指導物品擺放位置' },
        { id: 'day-10', text: '清點物品，確認沒有損壞或遺失' }
      ]
    },
    {
      title: '搬家後整理清單',
      icon: 'ri-home-smile-line',
      color: 'green',
      items: [
        { id: 'after-1', text: '優先整理臥室和衛浴，確保當晚能休息' },
        { id: 'after-2', text: '組裝床架、衣櫃等大型家具' },
        { id: 'after-3', text: '連接電器，測試是否正常運作' },
        { id: 'after-4', text: '整理廚房，確保能正常煮食' },
        { id: 'after-5', text: '拆除打包材料，分類回收' },
        { id: 'after-6', text: '清潔新家，擦拭家具和地板' },
        { id: 'after-7', text: '測試水電瓦斯、網路是否正常' },
        { id: 'after-8', text: '更新身分證、駕照地址' },
        { id: 'after-9', text: '通知公司、學校地址變更' },
        { id: 'after-10', text: '認識新鄰居，了解社區規定' }
      ]
    }
  ];

  const calculateProgress = () => {
    const totalItems = checklists.reduce((sum, list) => sum + list.items.length, 0);
    const checkedCount = Object.values(checkedItems).filter(Boolean).length;
    return Math.round((checkedCount / totalItems) * 100);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-teal-50">
      <SchemaOrg type="website" />

      {/* Hero Section */}
      <section className="relative py-12 md:py-16 bg-gradient-to-r from-teal-600 to-emerald-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            <strong>搬家檢查清單</strong>
          </h1>
          <p className="text-lg md:text-xl text-teal-100 mb-6">
            完整的<strong className="text-white">搬家準備流程</strong>，讓您不遺漏任何細節
          </p>
          <div className="flex items-center justify-center gap-2 text-white/90">
            <i className="ri-checkbox-circle-line text-2xl"></i>
            <span>從 4 週前到搬家後 · 完整規劃 · 輕鬆搬家</span>
          </div>
        </div>
      </section>

      {/* Progress Bar */}
      <section className="py-8 bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between mb-3">
            <h3 className="text-lg font-bold text-gray-900">
              <i className="ri-trophy-line text-teal-600 mr-2"></i>
              完成進度
            </h3>
            <span className="text-2xl font-bold text-teal-600">{calculateProgress()}%</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
            <div 
              className="bg-gradient-to-r from-teal-500 to-emerald-500 h-full transition-all duration-500 rounded-full"
              style={{ width: `${calculateProgress()}%` }}
            ></div>
          </div>
          <p className="text-sm text-gray-600 mt-2 text-center">
            已完成 {Object.values(checkedItems).filter(Boolean).length} / {checklists.reduce((sum, list) => sum + list.items.length, 0)} 項
          </p>
        </div>
      </section>

      {/* Checklists */}
      <section className="py-12 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-8">
            {checklists.map((checklist, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden">
                <div className={`bg-gradient-to-r from-${checklist.color}-500 to-${checklist.color}-600 p-6`}>
                  <div className="flex items-center gap-4">
                    <div className="bg-white/20 w-14 h-14 rounded-xl flex items-center justify-center">
                      <i className={`${checklist.icon} text-3xl text-white`}></i>
                    </div>
                    <div className="flex-1">
                      <h2 className="text-2xl font-bold text-white mb-1">{checklist.title}</h2>
                      <div className="flex items-center gap-4 text-white/90 text-sm">
                        <span>
                          {checklist.items.filter(item => checkedItems[item.id]).length} / {checklist.items.length} 已完成
                        </span>
                        <span>•</span>
                        <span>
                          {Math.round((checklist.items.filter(item => checkedItems[item.id]).length / checklist.items.length) * 100)}%
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="p-6">
                  <div className="space-y-3">
                    {checklist.items.map((item) => (
                      <label
                        key={item.id}
                        className={`flex items-start gap-4 p-4 rounded-xl border-2 transition-all cursor-pointer ${
                          checkedItems[item.id]
                            ? `border-${checklist.color}-500 bg-${checklist.color}-50`
                            : 'border-gray-200 hover:border-gray-300 bg-white'
                        }`}
                      >
                        <input
                          type="checkbox"
                          checked={checkedItems[item.id] || false}
                          onChange={() => toggleItem(item.id)}
                          className={`w-6 h-6 text-${checklist.color}-600 rounded focus:ring-${checklist.color}-500 cursor-pointer mt-0.5 flex-shrink-0`}
                        />
                        <span className={`text-gray-700 leading-relaxed ${checkedItems[item.id] ? 'line-through text-gray-400' : ''}`}>
                          {item.text}
                        </span>
                      </label>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Tips Section */}
      <section className="py-12 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">搬家小技巧</h2>
            <p className="text-lg text-gray-600">專業搬家公司的實用建議</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-gradient-to-br from-teal-50 to-emerald-100 rounded-xl p-6">
              <div className="bg-teal-600 w-12 h-12 rounded-full flex items-center justify-center mb-4">
                <i className="ri-box-3-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">打包技巧</h3>
              <ul className="space-y-2 text-gray-700 text-sm">
                <li>• 重物放小箱，輕物放大箱</li>
                <li>• 易碎品用氣泡紙包裹</li>
                <li>• 每個箱子都要標記內容物</li>
                <li>• 依房間分類打包</li>
              </ul>
            </div>

            <div className="bg-gradient-to-br from-emerald-50 to-teal-100 rounded-xl p-6">
              <div className="bg-emerald-600 w-12 h-12 rounded-full flex items-center justify-center mb-4">
                <i className="ri-time-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">時間規劃</h3>
              <ul className="space-y-2 text-gray-700 text-sm">
                <li>• 提前 3-4 週開始準備</li>
                <li>• 避開月初月底旺季</li>
                <li>• 平日搬家較優惠</li>
                <li>• 早上 8-9 點開始最佳</li>
              </ul>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-emerald-100 rounded-xl p-6">
              <div className="bg-teal-600 w-12 h-12 rounded-full flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">物品保護</h3>
              <ul className="space-y-2 text-gray-700 text-sm">
                <li>• 貴重物品自行攜帶</li>
                <li>• 家具邊角做好保護</li>
                <li>• 電器用原包裝最安全</li>
                <li>• 購買搬家保險更安心</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Related Articles */}
      <section className="py-12 md:py-20 bg-gradient-to-br from-gray-50 to-teal-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">延伸閱讀</h2>
            <p className="text-lg text-gray-600">更多實用的搬家知識</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <Link to="/knowledge/article/101" className="group cursor-pointer">
              <div className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all">
                <div className="h-48 overflow-hidden">
                  <img
                    src="https://public.readdy.ai/ai/img_res/f53c2f39f06a1f60500adb468e398054.jpg"
                    alt="2026 搬家打包技巧"
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                    2026 搬家打包技巧完整攻略
                  </h3>
                  <p className="text-gray-600 mb-4">專業打包技巧，讓搬家更輕鬆</p>
                  <div className="flex items-center text-sm text-gray-500">
                    <i className="ri-time-line mr-2"></i>
                    <span>10分鐘閱讀</span>
                  </div>
                </div>
              </div>
            </Link>

            <Link to="/knowledge/article/102" className="group cursor-pointer">
              <div className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all">
                <div className="h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Waste%20disposal%20and%20recycling%20sorting%20with%20organized%20bins%20and%20eco-friendly%20waste%20management%2C%20clean%20modern%20environment%20with%20proper%20waste%20separation&width=600&height=400&seq=waste2026&orientation=landscape"
                    alt="2026 垃圾清運法規"
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                    2026 垃圾清運法規更新完整指南
                  </h3>
                  <p className="text-gray-600 mb-4">了解最新法規，合法處理廢棄物</p>
                  <div className="flex items-center text-sm text-gray-500">
                    <i className="ri-time-line mr-2"></i>
                    <span>8分鐘閱讀</span>
                  </div>
                </div>
              </div>
            </Link>

            <Link to="/knowledge/article/103" className="group cursor-pointer">
              <div className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all">
                <div className="h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Insurance%20claim%20documents%20and%20protection%20shield%20with%20professional%20moving%20insurance%20concept%2C%20organized%20paperwork%20and%20security%20symbols&width=600&height=400&seq=insurance2026&orientation=landscape"
                    alt="2026 搬家理賠規範"
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                    2026 精緻搬家理賠規範完整指南
                  </h3>
                  <p className="text-gray-600 mb-4">了解理賠流程，保障您的權益</p>
                  <div className="flex items-center text-sm text-gray-500">
                    <i className="ri-time-line mr-2"></i>
                    <span>9分鐘閱讀</span>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-12 md:py-20 bg-gradient-to-r from-teal-600 to-emerald-600">
        <div className="max-w-4xl mx-auto px-4 text-center text-white">
          <h2 className="text-3xl font-bold mb-4">需要專業搬家服務？</h2>
          <p className="text-lg text-teal-100 mb-8">
            建鈞精緻搬家提供完整的搬家解決方案，讓您輕鬆搬家無煩惱
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://line.me/ti/p/@285yavdh"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-white text-teal-600 px-8 py-4 rounded-full text-lg font-bold hover:bg-gray-50 transition-all cursor-pointer shadow-lg hover:shadow-2xl whitespace-nowrap"
            >
              <img 
                src="https://static.readdy.ai/image/9ef47c451bf9aafd7a63eea67af7d95d/c33a3c3f2fa31df7dfad05bfabc09369.webp" 
                alt="LINE" 
                className="w-6 h-6"
                loading="lazy"
              />
              <span>LINE 免費諮詢</span>
            </a>
            <a
              href="tel:0978900081"
              className="inline-flex items-center justify-center gap-2 bg-teal-700 text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-teal-800 transition-all cursor-pointer shadow-lg hover:shadow-2xl whitespace-nowrap"
            >
              <i className="ri-phone-line text-xl"></i>
              <span>立即來電</span>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
